import React, { useState } from 'react'
import { Button, Modal, notification } from 'antd'
import axios from 'src/API/config'

export const ActionModal = ({ id, endpoint, text, title, refresh, type, ntftTitle, btnText, reqData }) => {
  const [api, contextHolder] = notification.useNotification()

  const [isModalOpen, setIsModalOpen] = useState(false)
  const showModal = () => {
    setIsModalOpen(true)
  }
  const handleOk = async () => {
    try {
      await axios[type](`${endpoint}/${id}`, reqData)

      await api.success({
        message: ntftTitle,
        description: 'Success',
        placement: 'topRight'
      })
    } catch (e) {
      await api.error({
        message: ntftTitle,
        description: 'Error',
        placement: 'topRight'
      })
    } finally {
      refresh()
    }

    setIsModalOpen(false)
  }
  const handleCancel = () => {
    setIsModalOpen(false)
  }
  return (
    <>
      {contextHolder}
      <Button type='primary' onClick={showModal}>
        {btnText}
      </Button>
      <Modal
        title={title}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText={btnText}
      >
        {text}
      </Modal>
    </>
  )
}
